import styled from 'styled-components';

export const Content = styled.div``;

export const Div = styled.div`
  &.captal {
    text-transform: capitalize;
  }
`;
